import React from 'react'
import {Tag, Tooltip} from 'antd'
import PropTypes from 'prop-types'
import {formatDate} from "../../../../helpers/formatDate"
import {onAddTab, onChangeActiveTab, onRemoveTab} from "../../../../store/action"
import {connect} from "react-redux"
import _checkRoles from "../../../../helpers/checkRole";
import {Link} from "react-router-dom";
import {formatNumber} from "../../../shared/Contants";
import CustomerForm from "../shared/CustomerForm"
import EditIcon from "../../../../statics/assets/icons/edit-outlined.svg"
import EyeIcon from "../../../../statics/assets/icons/eye-outlined.svg"
import ArrowRightIcon from "../../../../statics/assets/icons/arrow-right-outlined.svg"

CustomersItem.propTypes = {
    item: PropTypes.object
}

function CustomersItem(props) {
    const {item, index, page, limit, onAddTab} = props

    const _onAddTabDetail = (id, name) => {
        const payload = {
            idLeadDetail: id,
            id: `customerHubDetail_${id}`,
            title: name,
            icon: ''
        }
        onAddTab(payload)
    }

    const mapType = (value) => {
        return value === 'Trả sau'
            ? <Tag color="#87d068">{value}</Tag>
            : <Tag color="#108ee9">{value}</Tag>
    }

    return (
        <tr className={`CustomersItem ${index % 2 === 1 ? 'CustomersItem--stripe' : ''}`}>
            <td className="Stt">{(page - 1) * limit + index + 1}</td>
            <td className="Name">{item?.name}</td>
            <td className="Name">
                <span
                    className="cursor-pointer text-primary"
                    onClick={() => _onAddTabDetail(item.id, item.tenantFullName)}
                >
                    {item.tenantFullName || ''}
                </span>
                <span className="CreateAt">
                    {formatDate(item.createdAt)}
                </span>
            </td>
            <td className="Name">{item?.parentName}</td>
            <td className="Address">{item.address}</td>
            <td className="Description">{mapType(item?.billingPamentType)}</td>
            <td className="Source text-right">
                {item?.billingBalance && formatNumber(parseFloat(item?.billingBalance), 0, 3, '.', ',')}
            </td>
            <td className="Source">{item?.salePersonName}</td>
            {_checkRoles('menu.customerhub.viewCustomer') && (
                <td className="Actions">
                    <div className="Actions__group">
                        {_checkRoles('menu.customerhub.edit') && (
                            <Tooltip title="Sửa">
                                <div className="Actions__item">
                                    <CustomerForm item={item} type='edit' label='Sửa thông tin khách hàng'/>
                                </div>
                            </Tooltip>
                        )}
                        {_checkRoles('menu.customerhub.viewCustomer') && (
                            <Tooltip title="Xem chi tiết">
                                <div className="Actions__item" onClick={() => _onAddTabDetail(item.id, item.tenantFullName)}>
                                    <EyeIcon width={18} height={18}/>
                                </div>
                            </Tooltip>
                        )}
                        <Tooltip title="Báo cáo cước">
                            <Link
                                to={{
                                    pathname: 'report-call-fee',
                                    search: `?custId=${item.id}&custName=${item?.tenantFullName}`
                                }}
                                className="Actions__item"
                            >
                                <ArrowRightIcon width={18} height={18}/>
                            </Link>
                        </Tooltip>
                    </div>
                </td>
            )}
        </tr>
    )
}

const mapStateToProps = (state) => {
    return {
        tabs: state.tabsReducer.tabs,
        tabActive: state.tabsReducer.tabActive
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddTab: (data) => dispatch(onAddTab(data)),
        onRemoveTab: (data) => dispatch(onRemoveTab(data)),
        onChangeActiveTab: (data) => dispatch(onChangeActiveTab(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersItem)
